import styled from "@emotion/styled";

import {
    reactUiModalHeaderBottomPaddingMode2,
    reactUiModalLeftPadding,
    reactUiModalRightPadding,
} from "../../../Internals/ThemeProvider/ReactUiModalPaddings";
import { ListItem } from "../ErrorList/ErrorItem/ErrorsItem.styles";
import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const CountersContainer = styled.div(props => ({
    fontSize: theme(props).typography.primary.fontSize.css(),
    marginTop: theme(props).size(1),
    marginBottom: -reactUiModalHeaderBottomPaddingMode2,
}));

export const ListContainer = styled.div(props => ({
    marginLeft: -reactUiModalLeftPadding,
    marginRight: -reactUiModalRightPadding,
    ...theme(props).typography.primary.css(),

    [`${ListItem}`]: {
        boxSizing: "border-box",
        paddingLeft: reactUiModalLeftPadding - 15,
        paddingRight: reactUiModalRightPadding,
    },
}));
